import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

type NavItem = { label: string; to: string };

/**
 * plan.md > Navigation Structure. A role-appropriate item set per portal — all three portals
 * get a sidebar (the product owner confirmed this even though Manager/Employee only need a
 * couple of items) for a consistent pattern across the app.
 */
export function AppSidebar(props:
  | { role: "co_member" }
  | { role: "manager"; slug: string; takesTest: boolean }
  | { role: "employee"; slug: string },
) {
  const { t } = useTranslation();
  const items: NavItem[] = (() => {
    switch (props.role) {
      case "co_member":
        return [
          { label: t("nav.home", "Home"), to: "/co-member" },
          { label: t("nav.tests", "Tests"), to: "/co-member/tests" },
          { label: t("nav.questions", "Questions"), to: "/co-member/questions" },
          { label: t("nav.company", "Company"), to: "/co-member/companies" },
          { label: t("nav.dashboard", "Report"), to: "/co-member/dashboard" },
          { label: t("nav.settings", "Settings"), to: "/co-member/settings" },
        ];
      case "manager": {
        const base = `/company/${props.slug}`;
        const nav: NavItem[] = [
          { label: t("nav.home", "Home"), to: base },
          { label: t("nav.dashboard", "Report"), to: `${base}/dashboard` },
        ];
        // FR-039: "My Test" only appears for a Manager who is also a test-taker.
        if (props.takesTest) nav.push({ label: t("nav.myTest", "My Test"), to: `${base}/test` });
        nav.push({ label: t("nav.settings", "Settings"), to: `${base}/settings` });
        return nav;
      }
      case "employee": {
        const base = `/company/${props.slug}`;
        return [
          { label: t("nav.home", "Home"), to: `${base}/test` },
          { label: t("nav.dashboard", "Report"), to: `${base}/dashboard` },
          { label: t("nav.settings", "Settings"), to: `${base}/settings` },
        ];
      }
    }
  })();

  return (
    <nav className="flex w-48 flex-shrink-0 flex-col gap-1 border-r border-surface-alt bg-surface p-3">
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end
          className={({ isActive }) =>
            `rounded px-3 py-2 text-sm font-sans ${
              isActive ? "bg-brand text-surface" : "text-body hover:bg-surface-alt"
            }`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
